import { useState, useEffect } from 'react'

import showcaseImageA from '../../../custom_assets/home/showcase/showcase_1.png'
import showcaseImageB from '../../../custom_assets/home/showcase/showcase_2.png'
import showcaseImageC from '../../../custom_assets/home/showcase/showcase_3.png'

export const Showcase = () => {

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 1150);

  useEffect(() => {
    const updateScreenSize = () => setIsMobile(window.innerWidth <= 1150);
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  // useEffect(() => {
  //   const updateHeight = () => {
  //     const headlines: any = document.querySelectorAll(".dca-home-showcase-headline");
  //     const subheadlines: any = document.querySelectorAll(".dca-home-showcase-subheadline");
  //     let maxHeight = 0;

  //     headlines.forEach(headline => {
  //       headline.style.height = "auto";
  //     });

  //     headlines.forEach(headline => {
  //       maxHeight = Math.max(maxHeight, headline.clientHeight);
  //     });

  //     headlines.forEach(headline => {
  //       headline.style.height = `${maxHeight}px`;
  //     });

  //     // // //

  //     subheadlines.forEach(headline => {
  //       headline.style.height = "auto";
  //     });

  //     subheadlines.forEach(headline => {
  //       maxHeight = Math.max(maxHeight, headline.clientHeight);
  //     });

  //     subheadlines.forEach(headline => {
  //       headline.style.height = `${maxHeight}px`;
  //     });
  //   };

  //   // updateHeight();
  //   setTimeout(updateHeight, 0);

  //   window.addEventListener("resize", updateHeight);
  //   return () => window.removeEventListener("resize", updateHeight);
  // }, []);

  // return <div className="dca-home-showcase-content">
  //   <Fragment>
  //     <span className="dca-home-showcase-headline">{content.headline}</span>
  //     <span className="dca-home-showcase-subheadline">{content.subheadline}</span>
  //   </Fragment>

  //   <img className="dca-home-showcase-image" src={content.image} alt={content.imageAlt}></img>
  // </div>

  let showCaseContent = [
    {
      headline: 'AI-powered guidance',
      subheadline: 'Automated advice across key aspects of the college planning process',
      image: showcaseImageA,
      imageAlt: 'showcaseImageA'
    },
    {
      headline: 'Proprietary analytics',
      subheadline: 'Provide an advantage for formulating a successful application strategy',
      image: showcaseImageB,
      imageAlt: 'showcaseImageB'
    },
    {
      headline: 'Data-driven insights',
      subheadline: 'Add confidence to decision-making through the journey',
      image: showcaseImageC,
      imageAlt: 'showcaseImageC'
    }
  ]

  let mobileReturn = <div className="d-flex flex-column dca-home-showcase-wrapper">
    {showCaseContent.map((content, index) => (
      <div key={index} className="dca-home-showcase-item">
        <div className="dca-home-showcase-headline text-center">{content.headline}</div>
        <div className="dca-home-showcase-subheadline text-center">{content.subheadline}</div>
        <img
          className="dca-home-showcase-image"
          src={content.image}
          alt={content.imageAlt}
        />
      </div>
    ))}
  </div>

  let desktopReturn = <div className="d-flex flex-column dca-home-showcase-wrapper">
    <div className="dca-home-showcase-row">
      {showCaseContent.map((content, index) => (
        <div key={index} className="dca-home-showcase-cell">
          <div className="dca-home-showcase-headline">{content.headline}</div>
        </div>
      ))}
    </div>
    <div className="dca-home-showcase-row">
      {showCaseContent.map((content, index) => (
        <div key={index} className="dca-home-showcase-cell">
          <div className="dca-home-showcase-subheadline">{content.subheadline}</div>
        </div>
      ))}
    </div>
    <div className="dca-home-showcase-row">
      {showCaseContent.map((content, index) => (
        <div key={index} className="dca-home-showcase-cell">
          <img
            className="dca-home-showcase-image"
            src={content.image}
            alt={content.imageAlt}
          />
        </div>
      ))}
    </div>
  </div>

  return isMobile ? mobileReturn : desktopReturn
}